import React from 'react';

require('../css/progress.less');

export default class ProgressSpinner extends React.PureComponent {
  render() {
    return <div className='progress-spinner'></div>;
  }
}
